import classNames from 'classnames/bind'
import { InputTextField } from '@frontend-mono/shared/design-system'
import { Control, Controller } from 'react-hook-form'
import { useTranslation } from 'next-i18next'
import { playlistTitleRules } from '@frontend-mono/main/playlist/util-rules'
import styles from './TitleInput.module.scss'

const cx = classNames.bind(styles)

type TitleInputProps = {
  control: Control<{ title: string }>
  label?: string
  initialValue?: string
  checkIsDuplicated: (title: string) => boolean
  onKeyPress?: () => void;
}

export const TitleInput = ({
  control,
  label,
  initialValue,
  checkIsDuplicated,
  onKeyPress,
}: TitleInputProps) => {
  const { t } = useTranslation()

  return (
    <Controller
      name="title"
      control={control}
      defaultValue={initialValue}
      rules={playlistTitleRules(checkIsDuplicated)}
      render={({ field: { value, onChange, onBlur }, fieldState: { error, invalid } }) => (
        <InputTextField
          label={label}
          className={cx('input')}
          placeholder={t('Playlist__enter_playlist_name') ?? undefined}
          value={value ?? ''}
          error={invalid}
          onChange={onChange}
          onBlur={onBlur}
          onKeyPress={(e) => {
            if (e.key === 'Enter' && onKeyPress) {
              onKeyPress()
            }
          }}
          maxLength={20}
          helperText={error?.message}
        />
      )}
    />
  )
}
